import React from "react";
import ReactExport from "react-export-excel";

import { Button } from "@material-ui/core";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export const Download = (props) => {
  return (
    <ExcelFile
      element={
        <Button
          variant="contained"
          color="secondary"
          style={{ margin: "10px" }}
        >
          Exportar a Excel
        </Button>
      }
    >
      <ExcelSheet data={props.dataSet} name="Registros">
        <ExcelColumn label="Rp Cria" value="rpcria" />
        <ExcelColumn label="Fecha Nacimiento" value="nacimiento" />
        <ExcelColumn label="Peso" value="peso" />
        <ExcelColumn label="Sexo" value="sexo" />
        <ExcelColumn label="Rp Madre" value="rpmadre" />
        <ExcelColumn label="Padre" value="padre" />
        <ExcelColumn label="Raza" value="raza" />
        <ExcelColumn label="Color" value="color" />
        <ExcelColumn label="Tipo Registro" value="tregistro" />
        <ExcelColumn label="Observaciones" value="observaciones" />
        <ExcelColumn label="Fecha Registro" value="fecha" />
        <ExcelColumn label="Establecimiento" value="establecimiento" />
      </ExcelSheet>

      {/* esta seria otra pagina
        
        <ExcelSheet data={dataSet2} name="Leaves">
          <ExcelColumn label="Name" value="name" />
          <ExcelColumn label="Total Leaves" value="total" />
          <ExcelColumn label="Remaining Leaves" value="remaining" />
        </ExcelSheet> */}
    </ExcelFile>
  );
};
